var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 27,
    viewBox: "0 0 38 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 26,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 26,
    stroke: "#C9C9C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.826 13.847L11.006 11.85L10.191 13.847H11.826ZM19.685 16.008L19.68 12.086L17.944 16.008H16.894L15.152 12.082V16.008H12.718L12.258 14.891H9.765L9.3 16.008H8L10.144 11H11.922L13.958 15.742V11H15.912L17.479 14.397L18.918 11H20.912V16.008H19.685ZM22.818 14.984V13.987H25.446V12.965H22.818V12.054H25.819L27.129 13.514L25.761 14.984H22.818ZM30.929 16.028H29.373L27.899 14.369L26.367 16.028H21.625V11.018H26.44L27.913 12.66L29.436 11.018H31L28.673 13.523L30.929 16.028Z",
    fill: "#201E57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.2ef8d884c0eea92c1ed0913afcbb082c.svg";
export { ForwardRef as ReactComponent };